module.exports = __webpack_public_path__ + "static/Pech@2x.b1bd3983.png";